module.exports = __webpack_public_path__ + "media/3.7ad580b4.mp3";